import { useReveal } from "../../lib/useReveal";

const denied = [
    {
        title: "Negócios sem margem.",
        body: "Se a operação não comporta participação sobre receita, não há combustível para sustentar aquisição séria. Não fazemos milagre matemático.",
    },
    {
        title: "Empresas sem capacidade operacional.",
        body: "Entrega quebrada destrói qualquer estrutura de venda. Não vamos preencher um pipeline que o cliente não consegue atender.",
    },
    {
        title: "Donos que querem controlar a venda.",
        body: "Se o fundador insiste em conduzir o processo comercial pessoalmente, o nosso modelo perde sentido. Conversão precisa estar sob nossa régua.",
    },
    {
        title: "Quem procura apenas tráfego ou posts.",
        body: "Não somos pagos por entrega de mídia, criativo ou social. Quem busca prestador de serviço encontra centenas. Aqui não.",
    },
];

export default function QuemNaoAtendemos() {
    const ref = useReveal();
    return (
        <section
            data-testid="quem-nao-atendemos"
            id="quem-nao-atendemos"
            className="relative py-28 lg:py-40 border-t border-white/5"
        >
            <div ref={ref} className="reveal max-w-7xl mx-auto px-6 lg:px-10">
                <div className="max-w-4xl mb-16 lg:mb-24">
                    <div className="flex items-center gap-4 mb-8">
                        <span className="h-px w-10 bg-[#d4af37]" />
                        <span className="tag-fluxo">Seletividade</span>
                    </div>
                    <h2 className="font-['Outfit'] font-bold uppercase tracking-[-0.02em] text-4xl md:text-5xl lg:text-6xl leading-[0.95]">
                        Quem <span className="text-gold-gradient">não atendemos</span>.
                    </h2>
                    <p className="mt-8 text-white/55 leading-relaxed text-base md:text-lg max-w-2xl">
                        Nosso modelo só funciona em estruturas onde existe espaço
                        operacional, financeiro e estratégico para escala real. O
                        filtro vem antes do investimento.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/5">
                    {denied.map((d, i) => (
                        <div
                            key={i}
                            data-testid={`denied-${i}`}
                            className="bg-[#0a0a0a] p-8 lg:p-12 group transition-colors hover:bg-[#0f0f0f] relative"
                        >
                            <div className="absolute top-6 right-6 text-[#d4af37]/40 group-hover:text-[#d4af37] transition-colors text-2xl font-['Outfit'] font-light">
                                ×
                            </div>
                            <h3 className="text-white font-['Outfit'] font-semibold text-xl md:text-2xl leading-tight mb-4 pr-8">
                                {d.title}
                            </h3>
                            <p className="text-white/50 leading-relaxed text-sm md:text-base">
                                {d.body}
                            </p>
                        </div>
                    ))}
                </div>

                <div className="mt-20 max-w-3xl">
                    <p className="text-white/40 text-sm uppercase tracking-[0.25em] font-['Outfit']">
                        Capacidade limitada
                    </p>
                    <p className="mt-4 text-white text-xl md:text-2xl font-['Outfit'] leading-snug">
                        Operamos um número restrito de parcerias por ciclo. A entrada
                        é decidida em comitê interno.
                    </p>
                </div>
            </div>
        </section>
    );
}
